// add products to cart using there id
function productsToCart(productsIdAraay) {
  // Show loading state on the function trigger element
  window.HS_SLIDE_CART_OPEN();

  // Create an empty form data object
  let formData = {
    items: [],
  };

  // Iterate over the productsIdAraay array
  productsIdAraay.forEach((el) => {
    // Push each product ID and a quantity of 1 to the formData items array
    formData.items.push({
      id: el,
      quantity: 1,
    });
  });

  // Convert the formData object to a JSON string
  const postData = JSON.stringify(formData);

  // Send a POST request to add the items to the cart using fetch API
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json;",
    },
    body: postData,
  })
    .then((response) => {
      // Show loaded state on the function trigger element
      window.HS_SLIDE_CART_UPDATE();

      // Parse the response as JSON
      return response.json();
    })
    .catch((error) => {
      // Log any errors that occur during the request
      console.error("Error:", error);
    });
}
